// extracted by mini-css-extract-plugin
module.exports = {"container":"FullPageLoader_container__1xuvP"};